export const PILOT_MEMBERSHIP = "Pilot";
export const AGENCY_MEMBERSHIP = "Agency";
